/**
 * @desc 获取下一级组织架构信息(调整，parentId改为deptParentId)
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(deptParentId: string | number, options?: any) {
  return updateResponse(
    http(URL + `/organization/getChild/${deptParentId}`, {
      method: "GET",

      ...options,
    }),
  );
}
